import { Box } from '@mui/system';

import PitchImage from '../field-short.jpg';

type PitchProps = {
  children: React.ReactNode;
};

export const Pitch = ({ children }: PitchProps) => {
  return (
    <Box textAlign="center" style={{ position: 'relative' }}>
      <img
        src={PitchImage}
        alt="Pitch"
        style={{ width: '600px', height: 'auto' }}
      />
      {children}
    </Box>
  );
};
